import { faBars, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	sortableContainer,
	sortableElement,
	sortableHandle,
} from 'react-sortable-hoc';
import { ButtonAtom, PriorityIcon } from '../../../../components/atoms/atom';
import './priority-sortable-list.scss';

const DragHandle = sortableHandle(() => (
	<FontAwesomeIcon icon={faBars} style={{ cursor: 'pointer' }} />
));

const arrayMove = (arr, oldIndex, newIndex) => {
	const newArr = [...arr];
	if (newIndex >= newArr.length) {
		let k = newIndex - newArr.length + 1;
		while (k--) {
			newArr.push(undefined);
		}
	}
	newArr.splice(newIndex, 0, newArr.splice(oldIndex, 1)[0]);
	return newArr;
};

const PrioritySortableList = (props) => {
	const { listItems, onListItemSortEnd, onEdit, onDelete, t } = props;
	const totalItems = listItems?.length || 0;

	const onSortEnd = ({ oldIndex, newIndex }) => {
		onListItemSortEnd(arrayMove(listItems, oldIndex, newIndex));
	};

	const SortableItem = sortableElement(({ item, position, total }) => {
		return (
			<div className="priority-sortable-item">
				<div className="priority-col-drag">
					<DragHandle />
				</div>
				<div className="priority-col-order">
					<PriorityIcon position={position} total={total} />
				</div>
				<div className="priority-col-label">
					{item?.label}
				</div>
				<div className="priority-col-actions">
					<ButtonAtom
						className="btn btn-primary text-white mx-1"
						onClick={() => onEdit(item)}
					>
						<FontAwesomeIcon icon={faEdit} />
					</ButtonAtom>
					<ButtonAtom
						className="btn btn-primary text-white"
						onClick={() => onDelete(item)}
					>
						<FontAwesomeIcon icon={faTrash} />
					</ButtonAtom>
				</div>
			</div>
		);
	});

	const SortableList = sortableContainer(({ items, total }) => {
		return (
			<div className="priority-sortable-container">
				<div className="priority-sortable-header">
					<div className="priority-col-drag"></div>
					<div className="priority-col-order">{t('priority-order')}</div>
					<div className="priority-col-label">{t('label')}</div>
					<div className="priority-col-actions">{t('action')}</div>
				</div>
				{items.map((item, index) => (
					<SortableItem
						key={`priority-${item?.id}`}
						index={index}
						item={item}
						position={index + 1}
						total={total}
					/>
				))}
			</div>
		);
	});

	return <SortableList items={listItems} total={totalItems} onSortEnd={onSortEnd} useDragHandle />;
};

export default PrioritySortableList;
